<template>
  <header class="pos-header">

    <nav class="nav-section">
      <router-link to="/mobile-menu" class="nav-btn">
        <span class="icon">🍽</span>
        <span class="text">Menu</span>
      </router-link>

      <router-link to="/kitchen" class="nav-btn">
        <span class="icon">📋</span>
        <span class="text">Bếp</span>
      </router-link>

      <div class="nav-btn dropdown" @click="toggleDropdown" :class="{ 'active-dropdown': open }">
        <span class="icon">📊</span>
        <span class="text">Lịch sử</span>
        <span class="arrow" :class="{ 'flip': open }">▾</span>

        <transition name="pop">
          <div v-if="open" class="dropdown-panel" @click.stop>
            <div class="dropdown-header">Chọn thời gian</div>
            <router-link to="/history/today" class="dropdown-item" @click="open = false">
              Hôm nay
            </router-link>
            <router-link to="/history/monthly" class="dropdown-item" @click="open = false">
              Tháng này
            </router-link>
          </div>
        </transition>
      </div>
    </nav>

    <div class="action-section">
      <button @click="handleLogout" class="action-btn logout-btn">
        <span class="icon">🚪</span>
        Đăng xuất
      </button>
    </div>

  </header>
</template>

<script setup>
import { ref } from 'vue'
import { logout } from '../services/auth'

import { onMounted, onUnmounted } from 'vue'

const open = ref(false)

function toggleDropdown() {
  open.value = !open.value
}

function handleLogout() {
  if (confirm('Bạn có chắc chắn muốn đăng xuất?')) {
    logout()
  }
}

function handleClickOutside(e) {
  if (!e.target.closest('.dropdown')) {
    open.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* KIẾN TRÚC HEADER TỔNG THỂ */
.pos-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 24px;
  background-color: #0f172a;
  border-bottom: 1px solid #eaeaea;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* 1. LOGO SECTION */
.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 200px; /* Cố định width để nav luôn ở giữa */
}

.logo-icon {
  background: #ff7043;
  color: white;
  font-weight: 800;
  font-size: 14px;
  padding: 6px 10px;
  border-radius: 8px;
  letter-spacing: 1px;
}


/* 2. NAVIGATION SECTION */
.nav-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-btn {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 99px; /* Bo tròn dạng viên thuốc */
  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;
}

.nav-btn:hover {
  background-color: #f3f4f6;
  color: #111827;
}

/* Active State cho Nav */
.router-link-active {
  background-color: #fff3e0;
  color: #ff7043;
  border-color: #ffe0b2;
}

/* Nút Dropdown đặc biệt */
.active-dropdown {
  background-color: #f3f4f6;
  color: #111827;
}

.arrow {
  font-size: 12px;
  transition: transform 0.2s ease;
}
.arrow.flip {
  transform: rotate(180deg);
}

/* Bảng Dropdown */
.dropdown-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 200px;
  border-radius: 12px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid #f3f4f6;
  overflow: hidden;
}

.dropdown-header {
  padding: 12px 16px 8px;
  font-size: 12px;
  text-transform: uppercase;
  color: #9ca3af;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.dropdown-item {
  display: block;
  padding: 12px 16px;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}

.dropdown-item:hover {
  background-color: #f9fafb;
  color: #ff7043;
}

/* 3. ACTION SECTION */
.action-section {
  display: flex;
  justify-content: flex-end;
  width: 200px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.logout-btn {
  background-color: white;
  color: #ef4444;
  border: 1px solid #fee2e2;
}

.logout-btn:hover {
  background-color: #fef2f2;
  border-color: #fca5a5;
}

/* TRANSITION HIỆU ỨNG POP */
.pop-enter-active,
.pop-leave-active {
  transition: opacity 0.2s, transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px) scale(0.95);
}

/* ================= TỐI ƯU HEADER CHO ĐIỆN THOẠI ================= */
@media (max-width: 768px) {
  .dropdown-panel {
    position: fixed; /* Bứt ra khỏi thẻ div bị cuộn */
    top: 66px; /* Canh ngay sát dưới thanh header */
    left: 16px;
    right: 16px; /* Kéo dài ra 2 mép cho dễ bấm trên đt */
    width: auto;
    transform: none; /* Bỏ hiệu ứng căn giữa của PC đi */
    z-index: 9999; /* Đảm bảo nổi lên trên cùng */
  }
  .pos-header {
    padding: 0 10px; /* Giảm khoảng cách 2 bên mép màn hình */
    gap: 8px;
  }

  /* 1. Khu vực Logo: Giấu chữ, chỉ để icon */
  .logo-section {
    width: auto; /* Bỏ fix cứng 200px */
  }
  .logo-text {
    display: none;
  }

  /* 2. Khu vực Nav (Giữa): Vuốt ngang mượt mà */
  .nav-section {
    flex: 1;
    overflow-x: auto; /* Cho phép vuốt ngang */
    -webkit-overflow-scrolling: touch; /* Vuốt mượt trên iOS */
    white-space: nowrap; /* Không cho rớt dòng */
    scrollbar-width: none; /* Ẩn thanh cuộn Firefox */
  }
  .nav-section::-webkit-scrollbar {
    display: none; /* Ẩn thanh cuộn Chrome/Safari */
  }

  /* Chỉnh lại nút để không bị lỗi đè icon */
  .nav-btn {
    padding: 8px 12px;
    font-size: 14px;
  }

  /* 3. Khu vực Đăng xuất: Giấu chữ, chỉ để icon 🚪 */
  .action-section {
    width: auto; /* Bỏ fix cứng 200px */
  }
  .logout-btn {
    padding: 8px 10px;
    font-size: 0; /* Mẹo: Giấu chữ "Đăng xuất" đi */
    gap: 0;
  }
  .logout-btn .icon {
    font-size: 18px; /* Giữ lại icon to rõ */
  }
}
</style>